// C:\Users\VRS IT\Music\CleanSlate\cleanslate\src\Services\UserDataService.js
import api from "../axios";

export const GetUserData = async (token) => {
	try {
		const response = await api.post("User/GetUserData", { token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBasicData = async (PlayLoad) => {
	try {
		const response = await api.post("User/UpdateUserBasicDetails", PlayLoad);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBio = async (Bio, Token) => {
	try {
		const response = await api.post("User/UpdateUserBio", { Bio, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserProfileImage = async (Token, UserImage) => {
	try {
		const formData = new FormData();
		formData.append("Token", Token);
		formData.append("UserImage", UserImage);
		const response = await api.post("User/UpdateUserProfileImage", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data;
	} catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
};

export const UpdateUserMobileNo = async (MobileNo, PhoneCode, Token) => {
	try {
		const response = await api.post("User/UpdateUserMobileNo", {
			MobileNo,
			PhoneCode,
			Token,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateGender = async (Gender, Token) => {
	try {
		const response = await api.post("User/UpdateGender", { Gender, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateSex = async (Sex, Token) => {
	try {
		const response = await api.post("User/UpdateSex", { Sex, Token });
		return response.data;
	} catch (error) {
		if (error?.response?.data) {
            throw error.response.data;
        }
		throw error;
	}
};

export const UpdateMaritalStatus = async (MaritalStatus, Token) => {
	try {
		const response = await api.post("User/UpdateMarialStatus", { MaritalStatus, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserPeoplemanager = async (PeopleManager, Token) => {
	try {
		const response = await api.post("User/UpdateUserPeoplemanager", { PeopleManager, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateFamilytype = async (FamilyType, Token) => {
	try {
		const response = await api.post("User/UpdateFamilytype", { FamilyType, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateParentHoodStatus = async (ParentHood, Token) => {
	try {
		const response = await api.post("User/UpdateParentHoodStatus", { ParentHood, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserWorkProfile = async (WorkProfile, Token) => {
	try {
		const response = await api.post("User/UpdateUserWorkProfile", { WorkProfile, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserDOB = async (DOB, Token) => {
	try {
		const response = await api.post("User/UpdateUserDOB", { DOB, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserState = async (State , Token) => {
	try {
		const response = await api.post("User/UpdateUserState", { State , Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};


export const UpdateUserCity = async (City , Token) => {
	try {
		const response = await api.post("User/UpdateUserCity", { City , Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserCountry = async (Country , Token) => {
	try {
		const response = await api.post("User/UpdateUserCountry", { Country , Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserAccountProfileVisibility = async (ProfileVisibility, Token) => {
	try {
		const response = await api.post("User/UpdateUserAccountProfileVisibility", { ProfileVisibility, Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const GetBlogsCategories = async (Token , SearchPara = null) => {
	try {
		const response = await api.post("User/GetBlogsCategories", { Token });
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateBlogsCategories = async (payload) => {
	try {
		const response = await api.post("User/UpdateUserBlogsCategory", payload);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const RemoveUserBlogCategory = async (payload) => {
	try {
		const response = await api.post("User/RemoveUserBlogCategory", payload);
		return response.data;
	} catch (error) {
		throw error;
	}
};


export const GetBlogsTypes = async () => {
	try {
		const response = await api.post("User/GetBlogTypes");
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const GetAllBlogsByTypes = async (Token, BlogTypeId, page = 1, pageSize = 10) => {
	try {
		const response = await api.post("User/GetAllBlogByType", {
			Token,
			BlogTypeId, pageNumber: page, pageSize 
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const GetAllBlogs = async (Token, page = 1, pageSize = 10) => {
	try {
		const response = await api.post("User/GetAllBlogs", {
			Token, pageNumber: page, pageSize
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const InsertIntoPersonalDiary = async (payload) => {
	try {
		const response = await api.post("User/InsertIntoPersonalDiary", payload);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const GetUserPersonalDiary = async (pageNumber, token) => {
	if (!token) throw new Error("Token missing");

	const response = await api.post("User/GetInfoPersonalDiary", {
		token: token,
		pageNumber: pageNumber,
	});

	return response.data;
};

export const GetPersonalDiaryDates = async (token) => {
	try {
		if (!token) throw new Error("Token missing");

		const response = await api.post("User/GetPersonalDiaryDates", { Token: token });

		return response.data;
	} catch (error) {
		if (error?.response && error.response.data) {
			throw error.response.data;
		}
		throw error;
	}
};

export const GetUserBlogByType = async (Token, BlogTypeId , BlogStatus, page = 1, pageSize = 10) => {
	try {
		const response = await api.post("User/GetUserBlogByType", {
			Token,
			BlogTypeId,
			BlogStatus, pageNumber: page, pageSize
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const InsertUserDetails = async (formData) => {
	try {
		const response = await api.post("User/InsertUserBlog", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data;
	} catch (error) {
		// If server returned JSON (BadRequest), forward that object to caller
		if (error?.response && error.response.data) {
			// throw the server payload (e.g. { Status: "Fail", Message: "..." })
			throw error.response.data;
		}
		throw error;
	}
};

export const GetUserBlogByBlogId = async (Token, BlogUID) => {
	try {
		const response = await api.post("User/GetUserBlogById", {
			Token,
			BlogUID,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBlogTitle = async (Token, BlogUID, BLogTitle) => {
	try {
		const response = await api.post("User/UpdateUserBlogTitle", {
			Token,
			BlogUID,
			BLogTitle,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBlogDescription = async (
	Token,
	BlogUID,
	BLogDescription,
) => {
	try {
		const response = await api.post("User/UpdateUserBlogDescription", {
			Token,
			BlogUID,
			BLogDescription,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBlogImage = async (Token, BlogUID, BLogImage) => {
	try {
		const formData = new FormData();
		formData.append("Token", Token);
		formData.append("BlogUID", BlogUID);
		formData.append("BlogImage", BLogImage);
		const response = await api.post("User/UpdateUserBlogImage", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBlogStatus = async (Token, BlogUID, status) => {
	try {
		const response = await api.post("User/UpdateUserBlogStatus", {
			Token,
			BlogUID,
			status,
		});
		return response.data;
	} catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
};

export const UpdateUserBlogType = async (Token, BlogUID, BLogType) => {
	try {
		const response = await api.post("User/UpdateUserBlogType", {
			Token,
			BlogUID,
			BLogType,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const UpdateUserBlogTags = async (
	Token,
	BlogUID,
	BLogTagUid,
	TagNumber, //" expected :"1,2,3"
	aiSuggestedTags
) => {
	try {
		const response = await api.post("User/UpdateUserBlogTags", {
			Token,
			BlogUID,
			BLogTagUid,
			TagNumber,
			AISuggestedTags: aiSuggestedTags, 
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};


export const updateUserPersonalDiaryEntry = async (
	payload  
) => {
	try {
		const respsone = await api.post("User/InsertIntoPersonalDiary", payload );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const CreateSlamBook = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/CreateSlamBook", payload );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const GetSlamBookName = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetSlamBookName", payload );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const GetEmailDropdown = async (
	payload  
) => {
	try {
		const respsone = await api.post("User/GetAllEmailOfRegistredUser", payload ); // Token required
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}
}

export const DeleteSlamBookName = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/DeleteSlamBookName", payload ); // Token required and buuid of the slambook
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}
}

export const GetSlamBookDetailsByUUID = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetSlamBookDetailsByUUID", payload ); //Token and SlamBookUUID is required
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const GetLiveSlamBookDetailsByUUID = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetLiveSlamBookDetailsByUUID", payload ); //Token and SlamBookUUID is required
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const UpdateSlamBookTitle = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/UpdateSlamBookTitle", payload ); //Token and SlamBookUUID and slam book title
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const UpdateSlamBookUsers = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/UpdateSlamBookUsers", payload ); //Token , SlamBookUUID , removed user's , newuser is required 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const RemoveUpdateSlamBookQuestions = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/RemoveUpdateSlamBookQuestions", payload ); //Token , SlamBookUUID ,if removed QuestionUUID ,if newquestion required 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const UpdateSlamBookStatus = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/UpdateSlamBookStatus", payload ); //Token , SlamBookUUID ,Status required 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const UpdateSlamBookTitleStatusUsersQuestions = async (
	payload
) => {
	try {
		const respsone = await api.post("UserSlamBook/UpdateSlamBookTitleStatusUsersQuestions", payload);
		return respsone.data;
	}
	catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}
}

export const GetSharedSlamBookDetails = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetSharedSlamBookDetails", payload ); //Token required 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetLiveSlamBookAnswers = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetLiveSlamBookAnswers", payload ); //Token , SlamBookUUID , Quuid is required
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const UpdateStatusOfLiveSlamBook = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/UpdateStatusOfLiveSlamBook", payload ); 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetReceivedSlamBookDetailsByUUID = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/GetReceivedSlamBookDetailsByUUID", payload ); //Token and SlamBook UUID
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const SaveSlamBookResponse = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserSlamBook/SaveSlamBookResponse", payload ); // Token, BUUID, Status ('Draft'|'Completed'), Response: [{ QUUID, ResponseText }]
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetConnectionSuggestions = async (
	token , userTokenExpiry, searchParam = ""
) => {
	try {
		const respsone = await api.post("User/GetConnectionSuggestions", {token , userTokenExpiry, SearchParam: searchParam} ); //Token, tokenExpiry, optional SearchParam
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const CreateConnectionRequest = async (
	token , receiverUserUUId
) => {
	try {
		const respsone = await api.post("User/CreateConnectionRequest", {token , receiverUserUUId} ); //Token ,tokenExpiry
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetIncomingConnectionRequests = async (
	token , UserTokenExpiry
) => {
	try {
		const respsone = await api.post("User/GetIncomingConnectionRequests", {token , UserTokenExpiry} ); //Token ,tokenExpiry
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const RespondToConnectionRequest = async (
	token , Action , ConnectionId
) => {
	try {
		const respsone = await api.post("User/RespondToConnectionRequest", {token , ConnectionId , Action} );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetUserFriendList = async (token, cursor = null, pageSize = 10) => {
	try {
		// Clamp pageSize between 1-50 on the client to prevent abuse.
		const safePageSize = Math.min(Math.max(1, pageSize), 50);
		const cursorConnectedAt = cursor?.ConnectedAt ?? cursor?.connectedAt ?? cursor?.CursorConnectedAt ?? cursor?.cursorConnectedAt ?? null;
		const cursorConnectedId = cursor?.ConnectedId ?? cursor?.connectedId ?? cursor?.ConnectedID ?? cursor?.connectedID ?? cursor?.CursorConnectedId ?? cursor?.cursorConnectedId ?? null;

		const respsone = await api.post("User/GetUserFriendList", {
			Token: token,
			PageSize: safePageSize,
			CursorConnectedAt: cursorConnectedAt,
			CursorConnectedId: cursorConnectedId,
		});
		return respsone.data;
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const UnFollowUser = async (
	token , ConnectedID , FriendUUID
) => {
	try {
		const respsone = await api.post("User/UnFollowUser", {token , ConnectedID , FriendUUID} ); 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const CreateConversationAndSaveMessageOfUser = async (
	Token , ReceiverUserUUID , Content
) => {
	try {
		const respsone = await api.post("Message/CreateConversationAndSaveMessageOfUser", {Token , ReceiverUserUUID , Content} ); 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetUserInbox = async (
	Token ,UserTokenExpiry, page = 1, pageSize = 15
) => {
	try {
		const respsone = await api.post("Message/GetUserInbox", {Token , UserTokenExpiry, pageNumber: page, pageSize } ); 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}


export const GetConversationMessages = async (
	Token , ConversationUUID , PageNumber , PageSize
) => {
	try {
		const respsone = await api.post("Message/GetConversationMessages", {Token , ConversationUUID , PageNumber , PageSize} ); 
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const MarkConversationAsSeen = async (token, conversationUUID) => {
    try {
        const response = await api.post("Message/MarkConversationAsRead", {
            Token: token,
            ConversationUUID: conversationUUID,
        });
        return response.data;
    } catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
        throw error;
    }
};

export const DeleteUserMessage = async (token, conversationUUID, MessageUUIDs, DeleteType) => {
    try {
        const response = await api.post("Message/DeleteUserMessage", {
            Token: token,
            ConversationUUID: conversationUUID,
            MessageUUIDs: MessageUUIDs, // always array of MessageUUIDs to delete
            DeleteType: DeleteType, // 'From Everyone' or 'From Me'
        });
        return response.data;
    } catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};


export const GetSlamBookByShareToken  = async (token) => {
    try {
        const response = await api.post(`UserSlamBook/RespondByToken/${token}`);
        return response.data;
    } catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

 // #region ── NEW: call API helpers ──────────────────────────────────────
export const callInitiateAPI = async (token, receiverUserId, conversationId, conversationUUID, callerName, callerImg) => {
	try{
		const res = await api.post("Call/InitiateCall", {
		  Token: token, ReceiverUserId: receiverUserId,
		  ConversationId: conversationId, ConversationUUID: conversationUUID,
		  CallerName: callerName, CallerImg: callerImg || null,
		});
		return res.data;
	}
	catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
  };

export const callAnswerAPI = async (token, callUUID, conversationUUID, callerUserId, accepted, sdpAnswer) => {
	try {
		const res = await api.post("Call/AnswerCall", {
			Token: token, CallUUID: callUUID,
			ConversationUUID: conversationUUID, CallerUserId: callerUserId,
			Accepted: accepted, SdpAnswer: sdpAnswer || null,
		});
		return res.data;
	} catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}

};

export const callEndAPI = async (token, callUUID, conversationUUID, callerUserId, receiverUserId) => {
	try {
		const res = await api.post("Call/EndCall", {
			Token: token, CallUUID: callUUID,
			ConversationUUID: conversationUUID,
			CallerUserId: callerUserId, ReceiverUserId: receiverUserId,
		});
		return res.data;

	} catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}
};

export const callMissedAPI = async (token, callUUID, conversationUUID, receiverUserId) => {
	try {
		const res = await api.post("Call/MissedCall", {
			Token: token, CallUUID: callUUID,
			ConversationUUID: conversationUUID, ReceiverUserId: receiverUserId,
		});
		return res.data;
	} catch (error) {
		if (error?.response?.data) {
			throw error.response.data;
		}
		throw error;
	}
};
  // #endregion for call api's─────────────────────────────────────────────────────────────

//#region for Memoir =============================================================================================
export const CreateMemoirs = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserMemoirs/CreateMemoirs", payload );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const GetMemoirDashBoardData = async (
	payload  
) => {
	try {
		const respsone = await api.post("UserMemoirs/GetMemoirDashBoardData", payload );
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const GetMemoirsDetailsByUUID = async (payload  ) => {
	try {
		const respsone = await api.post("UserMemoirs/GetMemoirsDetailsByUUID", payload ); //token , MemoirUUID , status Draft or Live
		return respsone.data
	}
	catch (error) {
		if (error?.response?.data) {
			// rethrow server payload (could be { Status, Message, Errors } etc.)
			throw error.response.data;
		}
		throw error;
	}
}

export const UpdateMemoirs = async (payload) => {
    try {
        const response = await api.post("UserMemoirs/UpdateMemoir", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const DeleteMemoir = async (payloadOrToken, MemoirUUID) => {
    try {
        const payload = typeof payloadOrToken === 'object' && payloadOrToken !== null
            ? payloadOrToken
            : { Token: payloadOrToken, MemoirUUID };

        const response = await api.post("UserMemoirs/DeleteMemoir", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Payload: { Token, MUUID, QUUID, Col: "ExperienceWithMe" | "WhyDoIRemmberThis" | "Statement", Email? }
export const GetUserResponses = async (payload) => {
    try {
        const response = await api.post("UserMemoirs/GetUserResponses", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const GetMemoirByShareToken = async (shareToken) => {
    try {
        const response = await api.post(`UserMemoirs/RespondByToken/${shareToken}`);
        return response.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw error;
    }
};

export const SaveMemoirResponse = async (payload) => {
    try {
        const response = await api.post("UserMemoirs/SaveMemoirResponse", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw error;
    }
};

export const GetSharedMemoirDetailsByUUID = async (payload) => {
    try {
        const response = await api.post("UserMemoirs/GetSharedMemoirDetailsByUUID", payload);
        return response.data;
    } catch (error) {
        if (error?.response?.data) throw error.response.data;
        throw error;
    }
};

//#endregion 
